import React, {Component} from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import BoothMetadata from './booth-metadata';
import ScreenEmulator from '../screen-emulator/screen-emulator';
import ContentsList from './contents-list';

/** @class BothEditor
  * A component for editing booths and thier contents
  * in a virutal expo.
  */
export default class BoothEditor extends Component {
  /** @constructor
    * Creates a new BoothEditor component
    */
  constructor(props) {
    super(props);
    this.dataURL = `/expos/${props.expoID}/booths/${props.boothID}`;
  }
  /** @function render
    * Renders the component
    */
  render(){
    return(
      <Tabs>
        <TabList>
          <Tab>Properties</Tab>
          <Tab>Contents</Tab>
        </TabList>
        <TabPanel>
          <BoothMetadata dataURL={this.dataURL + '/metadata'}
            expoID={this.props.expoID}
            boothID={this.props.boothID}
            />
        </TabPanel>
        <TabPanel>
          <div className="content-tab">
            <div className="sidebar">
              <ContentsList dataURL={this.dataURL + '/contents'} />
            </div>
            <div className="screen">
              <ScreenEmulator src={'/preview/#' + this.dataURL + '/contents'} />
            </div>
          </div>
        </TabPanel>
      </Tabs>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-editor/booth-editor.js